import { KeyboardArrowDown, KeyboardArrowUp } from '@lichtblick/icons';
import { TextVariants } from '@lichtblick/theme';

import { Content, Header, Item, Root, Trigger } from './Foldout.styles';

import { Text } from '../Text';

type FoldoutProps = {
  children: React.ReactNode;
  hasFlippedArrow?: boolean;
  icon?: React.ReactElement;
  isOpen?: boolean;
  size?: 'small' | 'large';
  title: string;
  titleVariant?: keyof typeof TextVariants.header | keyof typeof TextVariants.body;
};

export const Foldout = ({
  children,
  hasFlippedArrow,
  icon,
  isOpen = true,
  size = 'large',
  title,
  titleVariant = 's',
}: FoldoutProps) => {
  const getVariant = () => {
    if (titleVariant === 'xs' || titleVariant === 's' || titleVariant === 'm' || titleVariant === 'l') {
      return TextVariants.body[titleVariant];
    }

    return TextVariants.header[titleVariant as keyof typeof TextVariants.header];
  };

  return (
    <Root $size={size} collapsible defaultValue={isOpen ? 'item' : ''} type="single">
      <Item value="item">
        <Header>
          <Trigger $size={size} data-testid="trigger">
            <div>
              {icon}
              <Text $variant={getVariant()}>{title}</Text>
            </div>
            {hasFlippedArrow ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </Trigger>
        </Header>
        <Content>{children}</Content>
      </Item>
    </Root>
  );
};
